function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/* global rmlOpts */
import React from "react";
import { blocks, components, element, editor, i18n } from "wp";
const BLOCK_ID = "real-media-library/gallery",
      {
  registerBlockType
} = blocks,
      {
  G,
  SVG,
  Path,
  ServerSideRender,
  PanelBody,
  RangeControl,
  ToggleControl,
  SelectControl,
  TreeSelect,
  Notice,
  Spinner,
  Button,
  withNotices
} = components,
      {
  Component,
  Fragment
} = element,
      {
  InspectorControls
} = editor,
      {
  __
} = i18n;
const linkOptions = [{
  value: "attachment",
  label: __("Attachment Page")
}, {
  value: "media",
  label: __("Media File")
}, {
  value: "none",
  label: __("None")
}];
/**
 * Control to select a folder. You do not have to fill the items, it is
 * automatically filled and retrieved from the server.
 */

class SelectFolderControl extends Component {
  constructor() {
    super(...arguments);
    this.state = {
      $busy: true,
      tree: []
    };
  }
  /**
   * Load the RML tree.
   */


  async componentDidMount() {
    const {
      tree
    } = await window.rml.request({
      location: {
        path: "/tree"
      }
    });
    tree.unshift({
      id: -1,
      name: rmlOpts.others.lang.unorganized
    });
    tree.unshift({
      id: undefined,
      name: "-"
    });
    this.setState({
      tree,
      $busy: false
    });
  }

  render() {
    const { ...rest
    } = this.props,
          {
      $busy,
      tree
    } = this.state;
    return !$busy ? /*#__PURE__*/React.createElement(TreeSelect, _extends({
      label: rmlOpts.others.lang.folder
    }, rest, {
      tree: tree
    })) : /*#__PURE__*/React.createElement(Spinner, null);
  }

}
/**
 * Gallery edit view with inspector controls like the normal gallery block.
 */


class GalleryEdit extends Component {
  constructor() {
    super(...arguments);

    this.setFid = fid => this.props.setAttributes({
      fid: +fid
    });

    this.setLinkTo = linkTo => this.props.setAttributes({
      linkTo
    });

    this.setColumnsNumber = columns => this.props.setAttributes({
      columns
    });

    this.toggleImageCrop = () => this.props.setAttributes({
      imageCrop: !this.props.attributes.imageCrop
    });

    this.toggleCaptions = () => this.props.setAttributes({
      captions: !this.props.attributes.captions
    });

    this.handleReload = () => this.props.setAttributes({
      lastEditReload: new Date().getTime()
    });

    this.render = () => {
      // Collect data
      const {
        attributes
      } = this.props,
            {
        fid,
        columns = 3,
        imageCrop,
        captions,
        linkTo
      } = attributes;
      return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(InspectorControls, null, /*#__PURE__*/React.createElement(PanelBody, {
        title: __("Gallery Settings")
      }, /*#__PURE__*/React.createElement(SelectFolderControl, {
        value: fid,
        onChange: this.setFid
      }), /*#__PURE__*/React.createElement(RangeControl, {
        label: __("Columns"),
        value: columns,
        onChange: this.setColumnsNumber,
        min: "1",
        max: "8"
      }), /*#__PURE__*/React.createElement(ToggleControl, {
        label: __("Crop Images"),
        checked: !!imageCrop,
        onChange: this.toggleImageCrop
      }), /*#__PURE__*/React.createElement(ToggleControl, {
        label: __("Caption"),
        checked: !!captions,
        onChange: this.toggleCaptions
      }), /*#__PURE__*/React.createElement(SelectControl, {
        label: __("Link To"),
        value: linkTo,
        onChange: this.setLinkTo,
        options: linkOptions
      }), /*#__PURE__*/React.createElement(Button, {
        isPrimary: true,
        onClick: this.handleReload
      }, rmlOpts.others.lang.reloadContent))), /*#__PURE__*/React.createElement(ServerSideRender, {
        block: BLOCK_ID,
        attributes: attributes
      }), !fid && /*#__PURE__*/React.createElement(Notice, {
        status: "error",
        isDismissible: false
      }, /*#__PURE__*/React.createElement("p", null, rmlOpts.others.lang.gutenBergBlockSelect)));
    };

    this.state = {
      refresh: new Date().getTime()
    };
  }

}
/**
 * @see https://github.com/WordPress/gutenberg/blob/master/packages/block-library/src/gallery/index.js
 */


registerBlockType(BLOCK_ID, {
  title: "Real Media Library Gallery",
  description: "Display folder images in a rich gallery.",
  icon: /*#__PURE__*/React.createElement(SVG, {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement(Path, {
    fill: "none",
    d: "M0 0h24v24H0V0z"
  }), /*#__PURE__*/React.createElement(G, null, /*#__PURE__*/React.createElement(Path, {
    d: "M20 4v12H8V4h12m0-2H8L6 4v12l2 2h12l2-2V4l-2-2z"
  }), /*#__PURE__*/React.createElement(Path, {
    d: "M12 12l1 2 3-3 3 4H9z"
  }), /*#__PURE__*/React.createElement(Path, {
    d: "M2 6v14l2 2h14v-2H4V6H2z"
  }))),
  category: "common",
  supports: {
    align: true
  },
  attributes: {
    fid: {
      type: "number",
      default: 0
    },
    columns: {
      type: "number",
      default: 3
    },
    imageCrop: {
      type: "boolean",
      default: true
    },
    captions: {
      type: "boolean",
      default: true
    },
    linkTo: {
      type: "string",
      default: "none"
    },
    lastEditReload: {
      type: "number",
      default: 0
    }
  },
  edit: withNotices(GalleryEdit),

  save() {
    // Rendering in PHP, see general\Gutenberg
    return null;
  }

});